/* eslint-disable */
import IntersectionObserver from '../vendors/intersection-observer-polyfill';

/**
 * @param {Object} options
 * @param {Array<string>|string} class
 * @param {boolean} multiple
 * @param {number} threshold
 */
export default {
  bind(el, binding) {
    const params = {
      class: binding.value.class
        ? Array.isArray(binding.value.class)
          ? binding.value.class
          : [binding.value.class]
        : typeof binding.value === 'string'
          ? binding.value.split(/\s/)
          : [],

      multiple: !!binding.value.multiple,
      threshold: binding.value.threshold ? binding.value.threshold : 0,
      callback: binding.value.callback ? binding.value.callback : null,
    };

    binding.value = params;

    const observer = new IntersectionObserver(
      (elements) => {
        elements.forEach(({ isIntersecting, target }) => {
          if (isIntersecting) {
            params.class.forEach((className) => {
              target.classList.add(className);
            });
            if (params.callback) {
              params.callback();
            }
            if (params.multiple === false) {
              binding.value.observer.unobserve(el);
            }
          } else {
            params.class.forEach((className) => {
              target.classList.remove(className);
            });
          }
        });
      },
      {
        threshold: params.threshold,
      },
    );

    binding.value.observer = observer;
    observer.observe(el);
  },

  unbind(el, binding) {
    if (binding.value.observer) {
      binding.value.observer.unobserve(el);
    }
  },
};
